import { useTranslation } from 'react-i18next';

const ContinueOnWeb = ({ href, source, className = '' }) => {
  const { t } = useTranslation();
  if (!href) return null;

  const track = () => {
    if (window.fbq) window.fbq('trackCustom', 'ContinueOnWeb', { source });
  };

  return (
    <div className={`mt-6 ${className}`}>
      <a
        href={href}
        onClick={track}
        className="inline-flex items-center justify-center w-full border border-gray-700 hover:border-white text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300"
      >
        {t('open.continueWeb')}
      </a>
      <p className="text-gray-500 text-sm mt-2">{t('open.continueWebHint')}</p>
    </div>
  );
};

export default ContinueOnWeb;
